import { useQuery } from "react-query";

import useQueryKey from "api/hooks/useQueryKey";
import { useAPI } from "libs/api";
import Cart from "models/Cart";
import { isNeitherNullNorUndefined } from "utils/stringUtils";

/**
 * The query hook to get the cart from the API.
 * @param {number} uuid The UUID of the cart to retrieve from the API.
 * @param {object} options The react-query useQuery options.
 * @returns {UseQueryResult<*, unknown>} The react-query preformatted useQuery hook to get the cart from the API.
 */
const useCartQuery = (uuid, options = {}) => {
  const api = useAPI("WeezPay");
  const queryKey = useQueryKey(["carts", uuid]);

  const { select } = options;

  return useQuery(
    queryKey,
    () => api.carts.get(uuid),
    {
      ...options,
      select: (data) => {
        if (!data || data?.errors?.length) {
          return select ? select({}) : {};
        }
        return select ? select(data) : Cart.fromAPI(data);
      },
      enabled: !!uuid && (isNeitherNullNorUndefined(options.enabled) ? options.enabled : true),
    },
  );
};

export default useCartQuery;
